// extracted by mini-css-extract-plugin
export default {"contentIframe":"ZenlegderIframe_contentIframe__G10tP"};